var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          staticClass: "mt-2",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-form-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { "offset-md": "2", "offset-lg": "3" } },
                        [
                          _c("avatar-form", {
                            attrs: {
                              avatar: _vm.avatar,
                              isReadonly: _vm.isReadonly
                            },
                            on: { onUpdateAvatar: _vm.updateAvatar }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "salutation",
                        label: _vm.$t(
                          "message.personalInformationForm.label.salutation"
                        ),
                        state: _vm.$v.salutation.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.personalInformationForm.salutation"
                        )
                      }
                    },
                    [
                      !_vm.isReadonly
                        ? _c("b-form-select", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "salutation",
                              options: _vm.salutations,
                              state: _vm.$v.salutation.$error ? false : null
                            },
                            on: {
                              changed: function($event) {
                                _vm.$v.salutation.$touch()
                              }
                            },
                            model: {
                              value: _vm.salutation,
                              callback: function($$v) {
                                _vm.salutation = $$v
                              },
                              expression: "salutation"
                            }
                          })
                        : _c("b-form-input", {
                            staticClass: "rounded-0",
                            class: { "text-muted": _vm.isReadonly },
                            attrs: {
                              id: "salutation",
                              disabled: _vm.isReadonly,
                              value: _vm.$t(
                                "enums.salutations." +
                                  _vm.personalInfo.salutation
                              )
                            }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "first-name",
                        label: _vm.$t(
                          "message.personalInformationForm.label.firstName"
                        ),
                        state: _vm.$v.firstName.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.personalInformationForm.firstName"
                        )
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          id: "first-name",
                          disabled: _vm.isReadonly,
                          state: _vm.$v.firstName.$error ? false : null
                        },
                        on: {
                          changed: function($event) {
                            _vm.$v.firstName.$touch()
                          }
                        },
                        model: {
                          value: _vm.firstName,
                          callback: function($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "date-of-birth",
                        label: _vm.$t(
                          "message.personalInformationForm.label.dateOfBirth"
                        ),
                        state: _vm.$v.dateOfBirth.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.personalInformationForm.dateOfBirth"
                        )
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        class: { "text-muted": _vm.isReadonly },
                        attrs: {
                          id: "date-of-birth",
                          placeholder: "TT.MM.JJJJ",
                          disabled: _vm.isReadonly,
                          state: _vm.$v.dateOfBirth.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.dateOfBirth.$touch()
                          }
                        },
                        model: {
                          value: _vm.dateOfBirth,
                          callback: function($$v) {
                            _vm.dateOfBirth = $$v
                          },
                          expression: "dateOfBirth"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "message.personalInformationForm.label.title"
                        ),
                        "label-for": "title"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        class: { "text-muted": _vm.isReadonly },
                        attrs: { id: "title", disabled: _vm.isReadonly },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "last-name",
                        label: _vm.$t(
                          "message.personalInformationForm.label.lastName"
                        ),
                        state: _vm.$v.lastName.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.personalInformationForm.lastName"
                        )
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        class: { "text-muted": _vm.isReadonly },
                        attrs: {
                          id: "last-name",
                          disabled: _vm.isReadonly,
                          state: _vm.$v.lastName.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.lastName.$touch()
                          }
                        },
                        model: {
                          value: _vm.lastName,
                          callback: function($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  _vm.isReadonly
                    ? _c(
                        "b-btn",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              _vm.setReadonly(!_vm.isReadonly)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "ti-pencil mr-2" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "message.personalInformationForm.btn.edit"
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: { variant: "danger" },
                              on: { click: _vm.cancel }
                            },
                            [
                              _c("span", { staticClass: "ti-close mr-2" }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.personalInformationForm.btn.cancel"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          this.$store.getters.currentUser.avatar
                            ? _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.deleteAvatarModal",
                                      modifiers: { deleteAvatarModal: true }
                                    }
                                  ],
                                  attrs: { variant: "danger" }
                                },
                                [
                                  _c("span", { staticClass: "ti-trash mr-2" }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("message.avatar.btn.delete")
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.submit }
                            },
                            [
                              _c("span", { staticClass: "ti-save mr-2" }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.personalInformationForm.btn.save"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "deleteAvatarModal",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.avatar.questionTitle"),
            "ok-title": _vm.$t("message.avatar.btn.yes"),
            "cancel-title": _vm.$t("message.avatar.btn.no")
          },
          on: { ok: _vm.deleteAvatar }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.avatar.question")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36644a64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36644a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/PersonalInformationForm.vue
// module id = vClX
// module chunks = 1